import { ItemModuleFragment } from 'generated/resources/graphql'

import Callout from 'modules/core/components/Callout'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useEffect } from 'modules/core/hooks/useEffect'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import useActiveSubscriptionOverload from 'modules/marketplace_modules/hooks/useActiveSubscriptionOverload'

import { findModuleNameById, getTrialRemainingDays } from './utils'

const UpsellTrialBanner = ({ module }: { module: ItemModuleFragment }) => {
  const { company } = useCurrentSession()
  const { activeSubscriptionOverload } = useActiveSubscriptionOverload([company.id])

  const dayCount = getTrialRemainingDays(activeSubscriptionOverload)
  const moduleName = findModuleNameById(module, activeSubscriptionOverload?.addonIds)

  useEffect(() => {
    if (moduleName) {
      track(trackingEvents.upsell.seeUpsellTrialBanner, { module_in_trial: moduleName })
    }
  }, [moduleName])

  if (!moduleName) return null

  return (
    <Callout
      compact
      type="warning"
      description={i18n.t('upsell_trial_banner.description', {
        day_count: dayCount,
        modules_in_trial: moduleName,
      })}
    />
  )
}

export default UpsellTrialBanner
